import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ILostReason } from "../lostReasonModel";

export const getAllLostReasons = createAsyncThunk(
  "LostReason/FindAllLostReason",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LostReason/FindAllLostReason`,
        {
          LostReason: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Lost Reasons:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createLostReason = createAsyncThunk(
  "LostReason/InsertLostReason",
  async (LostReasonData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LostReason/InsertLostReason`,
        LostReasonData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating lost reason:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateLostReason = createAsyncThunk(
  "LostReason/UpdateLostReason",
  async (LostReasonData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LostReason/UpdateLostReason`,
        LostReasonData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating lost reason:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteLostReason = createAsyncThunk(
  "LostReason/DeleteLostReason",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LostReason/DeleteLostReason`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting lost reason:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getLostReasonByID = createAsyncThunk(
  "LostReason/FindByIDLostReason",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LostReason/FindByIDLostReason`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        LostReason: result.LostReason,
        IsActive: result?.IsActive ? 1 : 2,
      } as ILostReason;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching lost reason:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveLostReasons = createAsyncThunk(
  "LostReason/FindAllActiveLostReason",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/LostReason/FindAllActiveLostReason`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Lost Reasons:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveLostReason = createAsyncThunk(
  "LostReason/ActiveInActiveLostReason",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LostReason/ActiveInActiveLostReason`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive lost reason:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
